<template>
  <section class="dflex-child_maxwidth">
    <div class="contacts cropped">
      <div class="contacts__wrapper">
        <div class="address">
          <TabsSwitcherHeader
            :value="value"
            :container="'contacts'"
            :buttonsSettings="settings1"
            @switchActiveButton="switcher"
          />
          <div v-if="iW <= 1248" class="phone">
            <ul>
              <li v-for="(item, index) in phoneandmail" :key="index" >
                <a :href="item.link"  :class="{'phone-changer': /tel/.test(item.link)}" >
                  {{ item.text }}
                </a>
              </li>
<!--              Раскомментировать если будет нужно пройти проверку и добавить для цикла li v-show="/tel/.test(item.link)" -->
             <li >
                 <a href="tel:+84956650068">8 495 665-00-68</a>
             </li>
             <li>
                 <a href="mailto:info@hopper-it.ru">info@hopper-it.ru</a>
             </li>
              <div class="socials">
                <a v-for="(item, index) in contactSocials" :key="index" :href="item.link" target="_blank" rel="nofollow" :class="['social', `social_${item.name}`]"></a>
              </div>
            </ul>
          </div>
          <TabsSwitcherBody
            :value="value"
            :container="'contacts'"
            :valuesOpenedTab="activeTabIndex"
            :tabsSettings="bodySettings1"
          />
        </div>
        <div v-if="iW > 1248" class="phone">
          <ul>
           <li v-for="(item, index) in phoneandmail" :key="index">
            <!-- <li v-for="(item, index) in phoneandmail" :key="index"> -->
              <a :href="item.link" :class="{'phone-changer': /tel/.test(item.link)}" >
                {{ item.text }}
              </a>
            </li>
<!--            раскомментировать  v-show="/tel/.test(item.link)"-->
           <!-- <li >
             <a href="tel:+84956650068">8 495 665-00-68</a>
           </li>
           <li>
             <a href="mailto:info@hopper-it.ru">info@hopper-it.ru</a>
           </li> -->
            <div class="socials">
              <a v-for="(item, index) in contactSocials" :key="index" :href="item.link" target="_blank" rel="nofollow" :class="['social', `social_${item.name}`]"></a>
            </div>
          </ul>
        </div>
      </div>
      <ContactForm
        :info="{ type: 'contacts', text: 'Связаться с нами', fields: formFileds }" type="message" :classes="['contacts__bottom__form']"
      />
    </div>
  </section>
</template>

<script>
import ContactForm from './contactForm.vue'
import TabsSwitcherHeader from './tabsSwitcherHeader.vue';
import TabsSwitcherBody from './tabsSwitcherBody.vue';

export default {
    name: 'contactsInside',
    components: {
        ContactForm,
        TabsSwitcherHeader,
        TabsSwitcherBody,
    },
    data() {
        return {
            activeTabIndex: 0,
        }
    },
    props: {
        formFileds: Array,
        settings1: Object,
        bodySettings1: Array,
        phoneandmail: Array,
        value: Object,
        contactSocials: Array,
        iW: Number
    },
    methods: {
        switcher(tabIndex) {
            this.activeTabIndex = tabIndex
        }
    }
}
</script>

<style lang="scss" scoped>
.buttons-group {
  display: flex;
  >button {
    &:first-child {
      margin-right: 10px;
    }
  }
}
.contacts {
  box-sizing: border-box;
  &.cropped {
    padding-bottom: 0;
  }
  &__wrapper {
    display: flex;
    margin-bottom: 64px;
  }
  @include largePhonesAlt {
    padding-left: 10px;
    padding-right: 10px;
  }
}
.address, .phone {
  width: 50%;
  @include mediumLaptop {
    width: 100%;
  }
}
.address {
  .address__info {
    .address__wrapper {
      @include mediumLaptop {
        max-width: unset;
      }
    }
    @include mediumLaptop {
      margin-top: 40px;
    }
  }
  @include mediumLaptop {
    display: flex;
    flex-direction: column;
  }
}
.phone {
  ul {
    margin: 0;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    width: 100%;
    list-style-type: none;
    padding: 0;
    >li {
        box-sizing: border-box;
        padding: 10px 0;
        width: 100%;
        &:first-child {
            border-top: 1px solid var(--color1);
        }
        &:not(list-child) {
            border-bottom: 1px solid var(--color1);
        }
        >a {
          font-size: 40px;
          line-height: 110%;
          color: var(--color1);
          text-decoration: none;
        }
    }

    .socials {
      @include mediumLaptop {
        margin-bottom: 0;
      }
    }
  }
  @include largePhonesAlt {
    ul {
      >li {
        >a {
          font-size: 18px;
        }
      }
    }
  }
}
.socials {
  padding-top: 16px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  .social {
    display: inline-flex;
    width: 40px;
    height: 40px;
    border: 1px solid var(--color1);
    border-radius: 100%;
    margin-right: 20px;
    background-size: 65% 65%;
    background-position: center;
    background-repeat: no-repeat;
    &_yt {
      background-image: url("data:image/svg+xml,%3Csvg width='21' height='13' viewBox='0 0 21 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M20.3866 4.91312C20.3866 4.52524 20.3128 4.07272 20.3128 3.55555C20.2389 3.03838 20.165 2.52121 20.0911 2.06868C19.9434 1.55151 19.7217 1.16364 19.2784 0.840405C18.909 0.517173 18.3918 0.323228 17.8747 0.258582C16.1754 0.0646424 13.6634 0 10.2649 0C6.86631 0 4.28044 0.0646424 2.65504 0.258582C2.13787 0.323228 1.6207 0.517173 1.25129 0.840405C0.881883 1.16364 0.586352 1.55151 0.438589 2.06868C0.290825 2.52121 0.216953 2.97373 0.216953 3.55555C0.143071 4.07272 0.143066 4.52524 0.143066 4.91312C0.143066 5.301 0.143066 5.75353 0.143066 6.39999C0.143066 7.04645 0.143066 7.56363 0.143066 7.88686C0.143066 8.27474 0.216953 8.72727 0.216953 9.24444C0.290834 9.76161 0.364707 10.2788 0.438589 10.7313C0.586352 11.2485 0.808002 11.6364 1.25129 11.9596C1.6207 12.2828 2.13787 12.4768 2.65504 12.5414C4.35432 12.7353 6.86631 12.8 10.2649 12.8C13.6634 12.8 16.2493 12.7353 17.8747 12.5414C18.3918 12.4768 18.909 12.2828 19.2784 11.9596C19.6478 11.6364 19.9434 11.2485 20.0911 10.7313C20.2389 10.2788 20.3128 9.82625 20.3128 9.24444C20.3867 8.72727 20.3866 8.27474 20.3866 7.88686C20.3866 7.49898 20.3866 7.04645 20.3866 6.39999C20.3866 5.75353 20.3866 5.23635 20.3866 4.91312ZM14.1806 6.91716L8.34394 10.0848C8.27006 10.1495 8.12229 10.2141 7.97453 10.2141C7.82677 10.2141 7.75288 10.2141 7.60512 10.1495C7.38348 10.0202 7.23571 9.82625 7.23571 9.56767V3.16767C7.23571 2.90908 7.38348 2.71515 7.60512 2.58586C7.82677 2.45656 8.12229 2.45656 8.34394 2.58586L14.1806 5.75353C14.4022 5.88282 14.55 6.07676 14.55 6.2707C14.55 6.46464 14.4022 6.78787 14.1806 6.91716Z' fill='%23001d82'/%3E%3C/svg%3E%0A");
    }
    &_tg {
      background-image: url("data:image/svg+xml,%3Csvg width='24' height='18' viewBox='0 0 24 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.686446 8.37408L5.94142 10.0886L7.98995 15.8557C8.07901 16.2454 8.61342 16.3233 8.96969 16.0895L11.9089 13.9853C12.1761 13.7515 12.6214 13.7515 12.9777 13.9853L18.2326 17.3364C18.5889 17.5702 19.1233 17.4144 19.2124 17.0247L23.1313 0.658655C23.2204 0.268988 22.7751 -0.120677 22.3297 0.0351905L0.686446 7.36095C0.152044 7.51681 0.152044 8.21821 0.686446 8.37408ZM7.72276 9.23135L18.0545 3.69807C18.2326 3.62013 18.4108 3.85394 18.2326 3.93187L9.77129 10.868C9.50408 11.1018 9.23688 11.4135 9.23688 11.8032L8.96969 13.6736C8.96969 13.9074 8.52435 13.9853 8.43528 13.6736L7.36647 10.2445C7.09927 9.85482 7.27742 9.38721 7.72276 9.23135Z' fill='%23001d82'/%3E%3C/svg%3E%0A");
    }
    &_fb {
      background-image: url("data:image/svg+xml,%3Csvg width='20' height='17' viewBox='0 0 20 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M19.5714 2.81865C19.5714 1.32124 18.0614 0 16.3501 0H3.36414C1.65281 0 0.142822 1.32124 0.142822 2.81865V14.1813C0.142822 15.6787 1.65281 17 3.36414 17H9.90743V10.5699H7.49145V7.7513H9.90743V6.60622C9.90743 4.66839 11.5181 2.99481 13.5314 2.99481H16.1487V5.81346H13.5314C13.2294 5.81346 12.9274 6.07772 12.9274 6.60622V7.7513H16.1487V10.5699H12.9274V17H16.3501C18.0614 17 19.5714 15.6787 19.5714 14.1813V2.81865Z' fill='%23001d82'/%3E%3C/svg%3E%0A");
    }
    &_ig {
      background-image: url("data:image/svg+xml,%3Csvg width='20' height='17' viewBox='0 0 20 17' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.2353 0H3.33637C1.76714 0 0.571533 1.04615 0.571533 2.41923V14.5808C0.571533 15.9538 1.76714 17 3.33637 17H17.2353C18.8045 17 20.0001 15.9538 20.0001 14.5808V2.41923C20.0001 1.04615 18.8045 0 17.2353 0ZM10.2858 13.6C13.499 13.6 16.1144 11.3769 16.1144 8.69615C16.1144 8.23846 16.0397 7.71538 15.8902 7.32308H17.5342V14.2538C17.5342 14.5808 17.2353 14.9077 16.7869 14.9077H3.78472C3.4111 14.9077 3.03747 14.6462 3.03747 14.2538V7.25769H4.75615C4.6067 7.71538 4.53197 8.17308 4.53197 8.63077C4.45725 11.3769 7.07263 13.6 10.2858 13.6ZM10.2858 11.6385C8.19351 11.6385 6.54955 10.2 6.54955 8.43462C6.54955 6.66923 8.19351 5.23077 10.2858 5.23077C12.3781 5.23077 14.0221 6.66923 14.0221 8.43462C14.0221 10.2654 12.3781 11.6385 10.2858 11.6385ZM17.4594 4.64231C17.4594 5.03461 17.0858 5.36154 16.6375 5.36154H14.5452C14.0968 5.36154 13.7232 5.03461 13.7232 4.64231V2.87692C13.7232 2.48462 14.0968 2.15769 14.5452 2.15769H16.6375C17.0858 2.15769 17.4594 2.48462 17.4594 2.87692V4.64231Z' fill='%23001d82'/%3E%3C/svg%3E%0A");
    }
    &_vk {
      background-size: 18px;
      background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' y='0.5' width='17' height='17' rx='3' fill='%23001E82'/%3E%3Cpath d='M9.91167 7.41219C9.91167 7.76995 9.85425 8.1277 9.91167 8.48546C9.93375 8.63121 9.92492 8.8123 10.0928 8.8653C10.2606 8.9183 10.3401 8.7593 10.4328 8.6533C10.9584 8.0747 11.3383 7.40336 11.6298 6.68343C11.6651 6.5951 11.7004 6.50676 11.7402 6.42726C11.802 6.30359 11.9036 6.23293 12.0449 6.23293C12.6721 6.23293 13.3037 6.22409 13.9309 6.23734C14.2356 6.24176 14.3284 6.39635 14.2401 6.68785C14.1385 7.03235 13.9441 7.32828 13.7366 7.61536C13.4406 8.0217 13.1447 8.42362 12.8444 8.82996C12.438 9.38206 12.4425 9.45272 12.9327 9.93415C13.3611 10.3537 13.7984 10.7689 14.1296 11.2813C14.1694 11.3431 14.2091 11.4005 14.2356 11.4668C14.3461 11.7273 14.2312 11.9614 13.9574 12.0277C13.8735 12.0498 13.7807 12.063 13.6968 12.0586C13.233 12.0542 12.7693 12.0498 12.3055 12.0409C11.9787 12.0365 11.7049 11.9084 11.4796 11.6788C11.2499 11.4403 11.0247 11.1973 10.795 10.9588C10.7111 10.8705 10.6228 10.7866 10.5212 10.7159C10.3136 10.5657 10.1193 10.632 10.0442 10.8793C9.97792 11.1002 9.93375 11.3298 9.90725 11.5595C9.8675 11.8863 9.74383 12.0056 9.41699 12.0233C7.97272 12.1204 6.81112 11.5728 5.91011 10.4553C5.02235 9.35555 4.37751 8.11445 3.79891 6.8336C3.75916 6.74968 3.715 6.66577 3.6885 6.57301C3.62225 6.36543 3.71941 6.21526 3.93583 6.21084C4.47026 6.19318 5.00468 6.20643 5.54352 6.23293C5.77761 6.24618 5.91894 6.39193 6.00286 6.60835C6.28553 7.31944 6.65654 7.98195 7.12471 8.58704C7.19096 8.67096 7.25721 8.74605 7.34113 8.8123C7.53105 8.95805 7.6503 8.9183 7.71655 8.68863C7.76514 8.51638 7.79164 8.34412 7.80489 8.16745C7.82697 7.76553 7.80489 7.36361 7.77397 6.96169C7.75189 6.69668 7.5973 6.53326 7.33671 6.46701C7.15121 6.41843 7.12913 6.33451 7.26163 6.19317C7.36763 6.07834 7.50013 6.01651 7.65472 6.00326C8.24214 5.94584 8.83399 5.95467 9.42141 6.01209C9.73941 6.04301 9.88517 6.19759 9.89842 6.52001C9.9205 6.81593 9.91167 7.11186 9.91167 7.41219Z' fill='%23FDFDFE'/%3E%3C/svg%3E");
      &:active {
        background-color: var(--color1);
        background-image: url("data:image/svg+xml,%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Crect x='0.5' y='0.5' width='17' height='17' rx='3' fill='white'/%3E%3Cpath d='M9.91167 7.41219C9.91167 7.76995 9.85425 8.1277 9.91167 8.48546C9.93375 8.63121 9.92492 8.8123 10.0928 8.8653C10.2606 8.9183 10.3401 8.7593 10.4328 8.6533C10.9584 8.0747 11.3383 7.40336 11.6298 6.68343C11.6651 6.5951 11.7004 6.50676 11.7402 6.42726C11.802 6.30359 11.9036 6.23293 12.0449 6.23293C12.6721 6.23293 13.3037 6.22409 13.9309 6.23734C14.2356 6.24176 14.3284 6.39635 14.2401 6.68785C14.1385 7.03235 13.9441 7.32828 13.7366 7.61536C13.4406 8.0217 13.1447 8.42362 12.8444 8.82996C12.438 9.38206 12.4425 9.45272 12.9327 9.93415C13.3611 10.3537 13.7984 10.7689 14.1296 11.2813C14.1694 11.3431 14.2091 11.4005 14.2356 11.4668C14.3461 11.7273 14.2312 11.9614 13.9574 12.0277C13.8735 12.0498 13.7807 12.063 13.6968 12.0586C13.233 12.0542 12.7693 12.0498 12.3055 12.0409C11.9787 12.0365 11.7049 11.9084 11.4796 11.6788C11.2499 11.4403 11.0247 11.1973 10.795 10.9588C10.7111 10.8705 10.6228 10.7866 10.5212 10.7159C10.3136 10.5657 10.1193 10.632 10.0442 10.8793C9.97792 11.1002 9.93375 11.3298 9.90725 11.5595C9.8675 11.8863 9.74383 12.0056 9.41699 12.0233C7.97272 12.1204 6.81112 11.5728 5.91011 10.4553C5.02235 9.35555 4.37751 8.11445 3.79891 6.8336C3.75916 6.74968 3.715 6.66577 3.6885 6.57301C3.62225 6.36543 3.71941 6.21526 3.93583 6.21084C4.47026 6.19318 5.00468 6.20643 5.54352 6.23293C5.77761 6.24618 5.91894 6.39193 6.00286 6.60835C6.28553 7.31944 6.65654 7.98195 7.12471 8.58704C7.19096 8.67096 7.25721 8.74605 7.34113 8.8123C7.53105 8.95805 7.6503 8.9183 7.71655 8.68863C7.76514 8.51638 7.79164 8.34412 7.80489 8.16745C7.82697 7.76553 7.80489 7.36361 7.77397 6.96169C7.75189 6.69668 7.5973 6.53326 7.33671 6.46701C7.15121 6.41843 7.12913 6.33451 7.26163 6.19317C7.36763 6.07834 7.50013 6.01651 7.65472 6.00326C8.24214 5.94584 8.83399 5.95467 9.42141 6.01209C9.73941 6.04301 9.88517 6.19759 9.89842 6.52001C9.9205 6.81593 9.91167 7.11186 9.91167 7.41219Z' fill='%23001E82'/%3E%3C/svg%3E");
      }
    }
  }
  @include largePhonesAlt {
    margin-bottom: 40px;
    .social {
      width: 24px;
      height: 24px;
    }
  }
}
</style>

<style lang="scss">
.address {
    .address__wrapper {
      .address__item {
        @include mediumLaptop {
          margin-bottom: 0;
        }
      }
      @include mediumLaptop {
        display: flex;
        row-gap: 32px;
        max-width: unset;
      }
    }
}
</style>